import { createContext } from "react";

interface NavigationMenuContextType {
  collapsed: boolean;
  toggleCollapsed: () => void;
  closeMobile: () => void;
}

export const NavigationMenuContext =
  createContext<NavigationMenuContextType | null>(null);
